<template>
  <div>
    <div>
      <h4>{{ $t('companyDetails.form.deleteToken') }}</h4>
    </div>

    <div class="vp-my-30">
      <p class="modal-paragraph" v-html="$t('companyDetails.form.deleteTokenConfirm')"/>
    </div>

    <hr />

    <div
      class="d-flex justify-content-around items-align-center vp-width-percent-70"
      style="margin:auto"
    >
      <b-button
        variant="primary"
        type="button"
        class="text-center modal-buttonSize"
        @click="$bvModal.hide('confirm-delete')"
      >
        <span>{{ $t('common.cancel')}}</span>
      </b-button>

      <b-button
        variant="outline-danger"
        type="button"
        class="text-center modal-buttonSize"
        @click="onConfirmHandler"
      >
        <span>{{ $t('common.delete')}}</span>
      </b-button>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    onConfirmHandler() {
      this.$emit("confirm-delete");
      this.$bvModal.hide("confirm-delete");
    },
  },
};
</script>
<style lang="scss" scoped>
.modal-buttonSize {
  width: 111.69px !important;
  height: 33.26px;
  margin-top: 20px !important;
  border-radius: 20px;
}
.modal-paragraph {
  font-weight: 400;
  font-size: 20px !important;
  line-height: 26px;
  text-align: center;
  letter-spacing: 0.25px;
  color: #939393;
}
</style>
